export function textWithFilterCount(text: string, filterCount: number): string {
  return filterCount > 0 ? `${text} (${filterCount})` : text
}
